import { withRouter } from 'react-router-dom'
import {connect} from 'react-redux';
import ForgotPasswordForm from '../components/ForgotPasswordForm';
import {authenticateEmail, tryNewEmailAddress} from '../actions';
import { mapForgotPasswordToProps } from '../selectors';

export const ForgotPasswordFormContainer = connect(mapForgotPasswordToProps, {onSubmit: authenticateEmail, tryNewEmailAddress})(ForgotPasswordForm);

export default withRouter(ForgotPasswordFormContainer);